module.exports = __webpack_public_path__ + "img/newsList.4b7e824c.png";